import { render, staticRenderFns } from "./ConsumeByOT.vue?vue&type=template&id=5106b65a&"
import script from "./ConsumeByOT.vue?vue&type=script&lang=js&"
export * from "./ConsumeByOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports